import { render, staticRenderFns } from "./server_error.vue?vue&type=template&id=45ffc9a4&"
import script from "./server_error.vue?vue&type=script&lang=js&"
export * from "./server_error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports